const Suits = {
    SPADES: 'S',
    HEARTS: 'H',
    DIAMONDS: 'D',
    CLUBS: 'C',
};

const SuitsList = Object.values(Suits);

const CardNumbers = {
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    SIX: 6,
    SEVEN: 7,
    EIGHT: 8,
    NINE: 9,
    TEN: 'T',
    JACK: 'J',
    QUEEN: 'Q',
    KING: 'K',
    ACE: 'A',
};

//Короткая колода
const SixPlusDeck = [
    CardNumbers.ACE,
    CardNumbers.KING,
    CardNumbers.QUEEN,
    CardNumbers.JACK,
    CardNumbers.TEN,
    CardNumbers.NINE,
    CardNumbers.EIGHT,
    CardNumbers.SEVEN,
    CardNumbers.SIX,
];

//Длинная колода
const FullDeck = [
    CardNumbers.ACE,
    CardNumbers.KING,
    CardNumbers.QUEEN,
    CardNumbers.JACK,
    CardNumbers.TEN,
    CardNumbers.NINE,
    CardNumbers.EIGHT,
    CardNumbers.SEVEN,
    CardNumbers.SIX,
    CardNumbers.FIVE,
    CardNumbers.FOUR,
    CardNumbers.THREE,
    CardNumbers.TWO,
];

const svgPlus = `<svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.4992 25C20.0162 25 25.2992 19.6274 25.2992 13C25.2992 6.37258 20.0162 1 13.4992 1C6.98226 1 1.69922 6.37258 1.69922 13C1.69922 19.6274 6.98226 25 13.4992 25Z"
                        stroke="#989898" stroke-width="2" stroke-miterlimit="10" />
                <path d="M9.56641 13L17.4331 13" stroke="#989898" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                <path d="M13.5 9L13.5 17" stroke="#989898" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>`;

class Game {
    constructor(name, deck, user_card_count, max_player_count = 6, start_player_count = 2) {
        this.name = name;
        this.deck = deck;
        this.user_cards_count = user_card_count;
        this.max_player_count = max_player_count;
        this.start_player_count = start_player_count;
    }
}

//Все игры
const Games = {
    TEXAS_HOLDEM: new Game('texas_holdem', FullDeck, 2, 9, 2),
    OMAHA: new Game('omaha', FullDeck, 4),
    SIX_PLUS_DECK: new Game('sixplus_holdem', SixPlusDeck, 2),
    OMAHA_5CARDS: new Game('omaha_5cards', FullDeck, 5),
    OMAHA_6CARDS: new Game('omaha_6cards', FullDeck, 6),
};

//Все доступные игры
const AvailableGames = [
    Games.TEXAS_HOLDEM,
    Games.OMAHA,
    Games.SIX_PLUS_DECK,
    Games.OMAHA_5CARDS,
];

class DrawContent {
    constructor(jselector_id, outer_container) {
        this.jselector_id = jselector_id;
        this.jouter_container = outer_container;
        this.$elem = undefined;
    }

    draw() {
        this.draw_content();
    }

    bind_actions() {}

    draw_content(content) {
        if (content) {
            const selector = `#${this.jselector_id}`;
            if (this.$elem && $(selector).length) {
                this.$elem.replaceWith(content);
            } else {
                if (this.jouter_container) {
                    $(`#${this.jouter_container}`).append(content);
                } else {
                    $(selector).replaceWith(content);
                }
            }

            this.$elem = $(selector);
            this.bind_actions();
        }
    }

    destroy() {
        this.$elem?.remove();
    }
}

//Карта
class Card {
    constructor(number, suit) {
        this.number = number;
        this.suit = suit;

        const image_paths = {
            S: '/static/img/calculators/suit-spides.svg',
            H: '/static/img/calculators/suit-heart.svg',
            D: '/static/img/calculators/suit-diamonds.svg',
            C: '/static/img/calculators/suit-clubs.svg',
        };

        this.image_path = image_paths[suit];
    }

    get_string() {
        return `${this.number}${this.suit.toLowerCase()}`;
    }

    get_card() {
        return `<div class="calculator-deck__cards-card card-slot suit_${this.suit}">
            <span class="card-slot-number">${this.number}</span> <span class="card-slot-suit"><img src="${this.image_path}" alt="${this.number} ${this.suit}"></span></div>`;
    }
}

//Базовый класс слота для карты
class Slot extends DrawContent {
    constructor(...args) {
        super(...args);
        this.card = undefined;
    }

    get_card_string() {
        return this.card ? this.card.get_string() : undefined;
    }
}

class SlotState extends Slot {
    constructor(state, ...args) {
        super(...args);
        this.state = state;
        this.active = false;
    }

    activate_slot() {
        this.state.deactivate_slots();
        if (!this.active) {
            this.active = true;
            this.draw();
            this.state.add_popup_mobile(this);
            if (is_mobile) {
                this.build_mobile();
            }
        }
    }

    deactivate_slot() {
        if (this.active) {
            this.active = false;
            this.draw();
            if (is_mobile) {
                this.build_mobile();
            }
        }
    }

    delete_card() {
        if (this.card) {
            this.state.unblock_card(this.card);
            this.card = undefined;
        }
    }

    bind_actions() {
        this.$elem.off('click').on('click', () => {
            if (this.card) {
                this.delete_card();
                this.activate_slot();
                this.state.check_state();
            } else if (!this.active) {
                this.activate_slot();
            } else {
                this.deactivate_slot();
            }
        });
    }

    destroy() {
        this.card = undefined;
        this.active = false;
    }
}

//Слот карты для игроков
class PlayerSlot extends SlotState {
    constructor(jouter_container, player, slot_number, ...args) {
        super(player.state, ...args);
        this.player = player;
        this.jselector_id = `${player.jselector_id}_${slot_number}`;
        this.jselector_id_mobile = `${player.jselector_id}_mobile_${slot_number}`;
        this.jouter_container = jouter_container;
        this.mobile_id = this.state.mobile_slots_id;
    }

    get_string() {
        const card_slot_classes = `card-slot${this.active ? ' card-slot_active' : ''}`;
        const slot_content = this.card ? this.card.get_card() : svgPlus;
        return [card_slot_classes, slot_content];
    }

    draw() {
        const data = this.get_string();
        this.draw_content(`<div id="${this.jselector_id}" class="${data[0]}">${data[1]}</div>`);
    }

    draw_mobile(container) {
        const data = this.get_string();
        const slotHtml = `<div id="${this.jselector_id_mobile}" class="${data[0]}">${data[1]}</div>`;
        $(`#${container}`).append(slotHtml);

        this.$elem = $(`#${this.jselector_id_mobile}`);
        this.bind_actions();
    }

    build_mobile() {
        this.player.draw_mobile();
    }
}

//Слот карты для стола
class BoardSlot extends SlotState {
    constructor(slot_number, board, ...args) {
        super(board.state, ...args);
        this.board = board;
        this.jselector_id = `board_${slot_number}`;
        this.jselector_id_mobile = `board_mobile_${slot_number}`;
        this.mobile_id = this.state.mobile_slots_id;
    }

    get_string() {
        const slot_content = this.card ? this.card.get_card() : svgPlus;
        const slot_wrapper_class = `card-slot${this.active ? ' card-slot_active' : ''}`;
        return [slot_wrapper_class, slot_content];
    }

    draw() {
        const data = this.get_string();
        this.draw_content(`<div id="${this.jselector_id}" class="${data[0]}">${data[1]}</div>`);
    }

    draw_mobile(container) {
        const data = this.get_string();
        const mobileHtml = `<div id="${this.jselector_id_mobile}" class="${data[0]}">${data[1]}</div>`;
        $(`#${container}`).append(mobileHtml);

        const clonedSlot = $(`#${this.jselector_id_mobile}`);
        console.log(clonedSlot)
        clonedSlot.off('click').on('click', () => {
            if (this.card) {
                this.delete_card();
                this.activate_slot();
                this.state.check_state();
            } else if (!this.active) {
                this.activate_slot();
            } else {
                this.deactivate_slot();
            }
        });

        if (this.active) {
            clonedSlot.addClass('card-slot_active');
        } else {
            clonedSlot.removeClass('card-slot_active');
        }

        this.$elem = $(`#${this.jselector_id}`);
        this.bind_actions();
    }

    build_mobile() {
        this.board.draw_mobile();
    }

    build_mobile() {
        this.board.draw_mobile();
    }
}

//Слот для карты в колоде
class DeckSlot extends Slot {
    constructor(card, suit_box, ...args) {
        super(...args);
        this.state = suit_box.state;
        this.card = card;
        this.blocked = false;
        this.suit_box = suit_box;
        this.jselector_id = `deck_slot_${card.number}${card.suit}`;
        this.jouter_container = suit_box.jselector_id;
    }

    draw() {
        const slot_classes = this.blocked ? ' _hidden' : '';
        this.draw_content(`<div id="${this.jselector_id}" class="${slot_classes}">${this.card.get_card()}</div>`);
    }

    bind_actions() {
        this.$elem.click(() => {
            if (!this.blocked) {
                const check_slot = this.suit_box.state.set_card_to_current_active_slot(this.card);
                if (check_slot) {
                    this.blocked = true;
                    this.draw();
                    this.state.check_state();
                }
            }
        });
    }
}

//Контейнер с картами одной масти в колоде
class SuiteBox extends DrawContent {
    constructor(suit, state, ...args) {
        super(...args);
        this.suit = suit;
        this.state = state;
        this.game = state.game;
        this.jselector_id = `${suit}`;
        this.deck_slots = this.initialize_deck_slots();
        this.$elem = $(`#${this.jselector_id}`);
    }

    initialize_deck_slots() {
        return this.game.deck.map(num => new DeckSlot(new Card(num, this.suit), this));
    }

    draw() {
        this.$elem.html('');
        this.deck_slots.forEach(deck_slot => deck_slot.draw());
    }

    unblock_card(card) {
        let result = false;
        this.deck_slots.some(deck_slot => {
            if (deck_slot.card.suit === card.suit && deck_slot.card.number === card.number) {
                deck_slot.blocked = false;
                deck_slot.draw();
                result = true;
                return true; // Прерываем цикл
            }
            return false;
        });
        return result;
    }

    destroy() {
        this.deck_slots.forEach(deck_slot => deck_slot.destroy());
    }
}

class DeactivateSlotsMixin extends DrawContent {
    constructor(...args) {
        super(...args);
        this.card_slots = [];
    }

    deactivate_slots() {
        this.card_slots.forEach(slot => slot.deactivate_slot());
    }

    set_card_to_current_active_slot(card) {
        for (let i = 0; i < this.card_slots.length; i++) {
            if (this.card_slots[i].active) {
                this.card_slots[i].card = card;
                if (i < this.card_slots.length - 1 && !this.card_slots[i + 1].card) {
                    this.card_slots[i + 1].activate_slot();
                } else if (i === this.card_slots.length - 1 && !this.card_slots[0].card) {
                    this.card_slots[0].activate_slot();
                } else {
                    this.card_slots[i].deactivate_slot();
                    if (this.set_active_to_next_element) {
                        this.set_active_to_next_element();
                    }
                }
                return true;
            }
        }
        return false;
    }
}

//Стол с картами
class Board extends DeactivateSlotsMixin {
    constructor(state, ...args) {
        super(...args);
        this.state = state;
        this.card_slots = this.initialize_card_slots();
        this.jselector_id = `board_main`;
        this.mobile_id = this.state.mobile_slots_id;
    }

    initialize_card_slots() {
        return Array.from({ length: 5 }, (_, i) => new BoardSlot(i + 1, this));
    }

    set_first_slot_active() {
        this.card_slots[0].active = true;
        this.state.redraw_all();
    }

    draw() {
        const title = `<div class="calculator-table__cards-header">Board</div>`;
        const first_slot_class = this.card_slots[0].active ? "card-slot_active" : "";
        const board_elem = `
            <div id="${this.jselector_id}"> ${title}
                <div class="calculator-table__cards-body">
                    <div class="calculator-table__cards-title fs-16 d-flex">Flop
                        <div class="calculator-table__cards-slot">
                            ${this.card_slots.slice(0, 3).map((_, i) => `<div id="board_${i + 1}" class="card-slot ${first_slot_class}"></div>`).join('')}
                        </div>
                    </div>
                    <div class="calculator-table__cards-title fs-16 d-flex">Turn
                        <div class="calculator-table__cards-slot">
                            <div id="calculator-table__tern">
                                <div id="board_4" class="card-slot"></div>
                            </div>
                        </div>
                    </div>
                    <div class="calculator-table__cards-title fs-16 d-flex">River
                        <div class="calculator-table__cards-slot">
                            <div id="calculator-table__river">
                                <div id="board_5" class="card-slot"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`;
        
        this.draw_content(board_elem);
        this.card_slots.forEach(slot => slot.draw());
    }

    draw_mobile() {
        const data = `<div id="${this.jselector_id}_mobile">
                <div class="d-flex flex-row gap-10">
                    <div class="calculator-table__cards-title fs-16 d-flex">Flop
                        <div class="calculator-table__cards-slot">
                            ${this.card_slots.slice(0, 3).map((_, i) => `<div id="board_${i + 1}_mobile" class="card-slot"></div>`).join('')}
                        </div>
                    </div>
                    <div class="calculator-table__cards-title fs-16 d-flex">Turn
                        <div class="calculator-table__cards-slot">
                            <div id="calculator-table__tern">
                                <div id="board_4_mobile" class="card-slot"></div>
                            </div>
                        </div>
                    </div>
                    <div class="calculator-table__cards-title fs-16 d-flex">River
                        <div class="calculator-table__cards-slot">
                            <div id="calculator-table__river">
                                <div id="board_5_mobile" class="card-slot"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`;
        
        const existingMobileElement = $(`#${this.mobile_id}`).find(`#${this.jselector_id}_mobile`);
        if (existingMobileElement.length) {
            existingMobileElement.replaceWith(data);
        } else {
            $(`#${this.mobile_id}`).append(data);
        }
        
        this.card_slots.forEach((slot, index) => {
            slot.draw_mobile(`board_${index + 1}_mobile`);
        });
    }

    bind_actions() {}

    destroy() {
        this.card_slots.forEach(slot => slot.destroy());
    }
}

//Игрок
class Player extends DeactivateSlotsMixin {
    constructor(state, player_name, user_number, active, ...args) {
        super(...args);
        this.state = state;
        this.game = state.game;
        this.name = player_name;
        this.number = user_number;
        this.jselector_id = `player_${user_number}`;
        this.jouter_container = state.player_container_id;
        this.card_slots = this.initialize_card_slots();
        this.draw_value = '0%';
        this.win_value = '0%';
        this.active = !!active;
        this.mobile_id = this.state.mobile_slots_id;
        if (!is_mobile) {
            this.set_first_slot_active();
        }
    }

    initialize_card_slots() {
        return Array.from({ length: this.game.user_cards_count }, (_, i) => new PlayerSlot(`player_slots_${this.number}`, this, i + 1));
    }

    set_first_slot_active() {
        if (this.number === 1) {
            this.card_slots[0].active = true;
        }
    }

    set_active_to_next_element() {
        if (this.state.players[this.number].active) {
            this.state.players[this.number].card_slots[0].active = true;
            this.state.redraw_all();
        } else {
            this.state.board.set_first_slot_active();
        }
    }

    draw() {
        const win_class = this.win_value.slice(0, -1) >= 50 ? 'c-tone-green-1 f-sbold' : 'c-tone-green-1';
        const player_delete = this.number > this.game.start_player_count ? `
            <button id="player_delete_${this.number}" class="calculator-user__delete">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.25 5.25L3.75 5.25001" stroke="#EBEBEB" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.75 9.75V15.75" stroke="#EBEBEB" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14.25 9.75V15.75" stroke="#EBEBEB" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M18.75 5.25V19.5C18.75 19.6989 18.671 19.8897 18.5303 20.0303C18.3897 20.171 18.1989 20.25 18 20.25H6C5.80109 20.25 5.61032 20.171 5.46967 20.0303C5.32902 19.8897 5.25 19.6989 5.25 19.5V5.25" stroke="#EBEBEB" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15.75 5.25V3.75C15.75 3.35218 15.592 2.97064 15.3107 2.68934C15.0294 2.40804 14.6478 2.25 14.25 2.25H9.75C9.35218 2.25 8.97064 2.40804 8.68934 2.68934C8.40804 2.97064 8.25 3.35218 8.25 3.75V5.25" stroke="#EBEBEB" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>` : '';

        const player_elem = this.active ? `
            <div id="${this.jselector_id}" class="calculator-user _user${this.number} cards_${this.game.user_cards_count}">
                <div class="calculator-user__wrapper">
                    <div class="calculator-user-title f-sbold">${this.name}</div>
                    <div class="calculator-user__pick">
                        <div id="player_slots_${this.number}" class="card-slot__wrapper"></div>
                        ${player_delete}
                    </div>
                </div>
                <div class="calculator-user__num">
                    <div class="${win_class}">${this.win_value} Win</div>
                    <div class="c-neutral-400">${this.draw_value} Tie</div>
                </div>
            </div>` : `
            <div id="${this.jselector_id}" class="calculator-user _user${this.number} calculator-user__button">
                <div class="fs-18">+Add player</div>
            </div>`;

        this.draw_content(player_elem);

        if (this.active) {
            this.card_slots.forEach(slot => slot.draw());
        }
    }

    draw_mobile() {
        const mobileContainer = $(`#${this.mobile_id}`);
        const mobileId = `${this.jselector_id}_mobile`;
        const data = `
            <div id="${mobileId}">
                <div class="f-sbold mb-2 fs-13 c-neutral-400">${this.name}</div>
                <div id="player_slots_${this.number}_mobile" class="card-slot__wrapper"></div>
            </div>
        `;

        const existingMobileElement = mobileContainer.find(`#${mobileId}`);
        if (existingMobileElement.length) {
            existingMobileElement.replaceWith(data);
        } else {
            mobileContainer.append(data);
        }

        this.card_slots.forEach(slot => {
            slot.draw_mobile(`player_slots_${this.number}_mobile`);
        });
    }

    bind_actions() {
        if (this.active) {
            $(`#player_delete_${this.number}`).click(() => {
                this.active = false;
                this.card_slots.forEach(slot => slot.delete_card());
                this.deactivate_slots();
                this.draw();
                this.state.check_state();
            });
        } else {
            this.$elem.click(() => {
                this.active = true;
                this.draw();
            });
        }
    }

    slots_full() {
        return this.card_slots.every(slot => slot.card);
    }
}

class ClearButton extends DrawContent {
    constructor(state, ...args) {
        super(...args);
        this.state = state;
        this.disabled = true;
    }

    draw() {
        const disabled = this.disabled ? 'disabled' : '';
        this.draw_content(`<button class="btn btn-link calculator-table__reset ${disabled}" id="${this.jselector_id}">
            Clear all
        </button>`);
    }

    bind_actions() {
        this.$elem.click(() => {
            this.state.clear_all();
        });
    }
}

//Общее состояние
class FullState {
    constructor(game) {
        this.init_all(game);
        this.events();
    }

    init_all(game) {
        this.game = game || Games.TEXAS_HOLDEM;
        this.player_container_id = 'player_container';
        this.mobile_slots_id = 'slots_container__mobile';
        this.suit_container_id = 'suit';
        this.players = this.initialize_players();
        this.board = new Board(this);
        this.deck = this.initialize_deck();
        this.clear_all_button = new ClearButton(this, 'table_reset', this.player_container_id);
        this.previous_calculate_state = this.get_calculate_state();
        this.default_state = this.previous_calculate_state;
        this.calc_api_host = $('#calc_api').data('val');
    }

    initialize_deck() {
        return SuitsList.map(suit => new SuiteBox(suit, this));
    }

    initialize_players() {
        return Array.from({ length: this.game.max_player_count }, (_, i) => {
            const isActive = i < this.game.start_player_count;
            return new Player(this, `Player ${i + 1}`, i + 1, isActive);
        });
    }

    draw_deck_suites() {
        this.deck.forEach(suit_box => suit_box.draw());
    }

    draw_players() {
        const $player_container = $(`#${this.player_container_id}`);
        $player_container.html('');
        this.players.forEach(player => player.draw());
        this.clear_all_button.draw();
    }

    draw() {
        document.getElementsByClassName('calculator-table')[0].setAttribute("id", this.game.name);
    }

    redraw_all() {
        this.draw();
        this.draw_deck_suites();
        this.draw_players();
        this.board.draw();
        this.board.card_slots.forEach(slot => slot.draw());
        this.clear_all_button.draw();
    }

    destroy_deck_suites() {
        this.deck.forEach(deck_suite => deck_suite.destroy());
    }

    destroy_players() {
        this.players.forEach((player, index) => {
            player.destroy();
            if (index === 0) {
                this.clear_all_button.destroy();
            }
        });
    }

    destroy_all() {
        this.destroy_deck_suites();
        this.destroy_players();
        this.board.destroy();
    }

    deactivate_slots() {
        this.players.forEach(player => player.deactivate_slots());
        this.board.deactivate_slots();
    }

    set_card_to_current_active_slot(card) {
        return this.players.some(player => player.set_card_to_current_active_slot(card)) || this.board.set_card_to_current_active_slot(card);
    }

    unblock_card(card) {
        return this.deck.some(suit_box => suit_box.unblock_card(card));
    }

    add_popup_mobile(item) {
        if (is_mobile) {
            $(`#${this.mobile_slots_id}`).empty();
            if (item.player) {
                item.player.card_slots.forEach(slot => slot.build_mobile());
            } else if (item.board) {
                item.board.card_slots.forEach(slot => slot.build_mobile());
            }
            document.body.classList.add("overflow-hidden");
            $('.calculator-deck__all').addClass('_active');
        }
    }

    events() {
        $('[data-close-deck]').click(e => {
            e.preventDefault();
            e.stopPropagation();
            this.remove_popup_mobile();
            this.deactivate_slots();
        });
    }

    remove_popup_mobile() {
        if (is_mobile) {
            $(`#${this.mobile_slots_id}`).empty();
            $('.calculator-deck__all').removeClass('_active');
            document.body.classList.remove("overflow-hidden");
        }
        this.draw_players();
    }

    clear_all() {
        if (is_mobile) {
            this.remove_popup_mobile();
        }
        this.board.card_slots.forEach(slot => {
            slot.delete_card();
            slot.deactivate_slot();
        });
        this.players.forEach(player => {
            player.card_slots.forEach(slot => {
                slot.delete_card();
                slot.deactivate_slot();
            });
            player.draw_value = '0%';
            player.win_value = '0%';
        });
        this.clear_all_button.disabled = true;
        this.players[0]?.set_first_slot_active();
        this.redraw_all();
    }

    get_calculate_state() {
        const board_cards = this.board.card_slots.map(card_slot => card_slot.get_card_string()).filter(Boolean);
        const players = this.players.map(player => player.card_slots.map(card_slot => card_slot.get_card_string()).filter(Boolean)).filter(player_state => player_state.length);
        return {
            game: this.game.name,
            board: board_cards,
            players: players
        };
    }

    send(cs) {
        $.ajax({
            url: `${this.calc_api_host}calculate/`,
            type: 'POST',
            data: JSON.stringify(cs),
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: data => {
                const players_active_ids = this.players.map((player, i) => player.slots_full() ? i : null).filter(i => i !== null);
                data.forEach((result, i) => {
                    this.players[players_active_ids[i]].draw_value = result.ties.replace('~', '');
                    this.players[players_active_ids[i]].win_value = result.wins.replace('~', '');
                    this.players[players_active_ids[i]].draw();
                });
            },
            error: () => {
                this.fake_state();
            }
        });
    }

    validate_state(cs) {
        if (cs.players.length < this.game.start_player_count) return false;
        return cs.players.every(player => player.length >= this.game.user_cards_count);
    }

    fake_state() {
        const cs = this.get_calculate_state();
        this.players.forEach(player => {
            player.draw_value = '50%';
            player.win_value = '50%';
            player.show_win_draw = true;
            player.draw();
        });
    }

    check_state() {
        const cs = this.get_calculate_state();
        if (JSON.stringify(cs) !== JSON.stringify(this.default_state)) {
            this.clear_all_button.disabled = false;
            this.clear_all_button.draw();
        }

        const valid = this.validate_state(cs);
        if (valid && JSON.stringify(cs) !== JSON.stringify(this.previous_calculate_state)) {
            this.previous_calculate_state = cs;
            this.send(cs);
        }
    }
}

$(document).ready(function () {
    const tableCacl = document.querySelector('.calculator-table');
    if (tableCacl) {
        async function run() {
            const full_state = new FullState();
            full_state.redraw_all();

            async function new_game(game) {
                full_state.clear_all();
                full_state.destroy_all();
                full_state.init_all(game);
                full_state.redraw_all();
            }

            const active_game = document.querySelector('input[name="game-type"]:checked');
            AvailableGames.forEach(a_game => {
                if (a_game.name === active_game.id) {
                    new_game(a_game);
                }
            });
        }
        run();
    }
});
